import { lazy } from 'react';

// project-imports
import ComponentLayout from '@/layout/Component';
import Loadable from '@/components/base-component/Loadable';

// render - inputs components page
const Autocomplete = Loadable(lazy(() => import('@/pages/examples/components-overview/autocomplete')));
const Buttons = Loadable(lazy(() => import('@/pages/examples/components-overview/buttons')));
const Checkbox = Loadable(lazy(() => import('@/pages/examples/components-overview/checkbox')));
const Radio = Loadable(lazy(() => import('@/pages/examples/components-overview/radio')));
const Rating = Loadable(lazy(() => import('@/pages/examples/components-overview/rating')));
const Select = Loadable(lazy(() => import('@/pages/examples/components-overview/select')));
const Slider = Loadable(lazy(() => import('@/pages/examples/components-overview/slider')));
const Switch = Loadable(lazy(() => import('@/pages/examples/components-overview/switch')));
const TextField = Loadable(lazy(() => import('@/pages/examples/components-overview/textfield')));

// render - feedback components page
const Alert = Loadable(lazy(() => import('@/pages/examples/components-overview/alert')));
const AlertConfirm = Loadable(lazy(() => import('@/pages/examples/components-overview/alert-confirm')));
const Dialogs = Loadable(lazy(() => import('@/pages/examples/components-overview/dialogs')));
const Progress = Loadable(lazy(() => import('@/pages/examples/components-overview/progress')));
const Snackbar = Loadable(lazy(() => import('@/pages/examples/components-overview/snackbar')));

// render - data display components
const Avatars = Loadable(lazy(() => import('@/pages/examples/components-overview/avatars')));
const Badges = Loadable(lazy(() => import('@/pages/examples/components-overview/badges')));
const Chips = Loadable(lazy(() => import('@/pages/examples/components-overview/chips')));
const Lists = Loadable(lazy(() => import('@/pages/examples/components-overview/lists')));
const Tooltip = Loadable(lazy(() => import('@/pages/examples/components-overview/tooltip')));
const Typography = Loadable(lazy(() => import('@/pages/examples/components-overview/typography')));

// render - navigation components page
const Breadcrumbs = Loadable(lazy(() => import('@/pages/examples/components-overview/breadcrumbs')));
const Pagination = Loadable(lazy(() => import('@/pages/examples/components-overview/pagination')));
const Speeddial = Loadable(lazy(() => import('@/pages/examples/components-overview/speeddial')));
const Stepper = Loadable(lazy(() => import('@/pages/examples/components-overview/stepper')));
const Tabs = Loadable(lazy(() => import('@/pages/examples/components-overview/tabs')));

// render - surfaces components page
const Accordion = Loadable(lazy(() => import('@/pages/examples/components-overview/accordion')));
const Cards = Loadable(lazy(() => import('@/pages/examples/components-overview/cards')));

// render - utils components page
const Color = Loadable(lazy(() => import('@/pages/examples/components-overview/color')));
const DateTimePicker = Loadable(lazy(() => import('@/pages/examples/components-overview/date-time-picker')));
const DateTimePickerBE = Loadable(lazy(() => import('@/pages/examples/components-overview/date-time-picker-BE')));
const Modal = Loadable(lazy(() => import('@/pages/examples/components-overview/modal')));
const Shadow = Loadable(lazy(() => import('@/pages/examples/components-overview/shadows')));
const Timeline = Loadable(lazy(() => import('@/pages/examples/components-overview/timeline')));
const TreeView = Loadable(lazy(() => import('@/pages/examples/components-overview/treeview')));

// render - utils components page
const Iconsax = Loadable(lazy(() => import('@/pages/examples/components-overview/iconsax')));
const ThemifyIcon = Loadable(lazy(() => import('@/pages/examples/components-overview/icon-themify')));
const Fontawesome = Loadable(lazy(() => import('@/pages/examples/components-overview/icon-fontawesome')));
const Radix = Loadable(lazy(() => import('@/pages/examples/components-overview/icon-radix')));
const BSIcon = Loadable(lazy(() => import('@/pages/examples/components-overview/iconBS')));
const Simple = Loadable(lazy(() => import('@/pages/examples/components-overview/icon-simple')));
const Hero2 = Loadable(lazy(() => import('@/pages/examples/components-overview/icon-hero2')));
const Bootstrap = Loadable(lazy(() => import('@/pages/examples/components-overview/icon-bootstrap')));

// render - forms & tables
const FormsValidation = Loadable(lazy(() => import('@/pages/examples/forms/validation')));
const FormsWizard = Loadable(lazy(() => import('@/pages/examples/forms/wizard')));

const FormsLayoutBasic = Loadable(lazy(() => import('@/pages/examples/forms/layouts/basic')));
const FormsLayoutMultiColumn = Loadable(lazy(() => import('@/pages/examples/forms/layouts/multi-column')));
const FormsLayoutActionBar = Loadable(lazy(() => import('@/pages/examples/forms/layouts/action-bar')));
const FormsLayoutStickyBar = Loadable(lazy(() => import('@/pages/examples/forms/layouts/sticky-bar')));

const FormsPluginsMask = Loadable(lazy(() => import('@/pages/examples/forms/plugins/mask')));
const FormsPluginsClipboard = Loadable(lazy(() => import('@/pages/examples/forms/plugins/clipboard')));
const FormsPluginsRecaptcha = Loadable(lazy(() => import('@/pages/examples/forms/plugins/re-captcha')));
const FormsPluginsEditor = Loadable(lazy(() => import('@/pages/examples/forms/plugins/editor')));
const FormsPluginsDropzone = Loadable(lazy(() => import('@/pages/examples/forms/plugins/dropzone')));

const ReactTableBasic = Loadable(lazy(() => import('@/pages/examples/tables/react-table/basic')));
const ReactDenseTable = Loadable(lazy(() => import('@/pages/examples/tables/react-table/dense')));
const ReactTableSorting = Loadable(lazy(() => import('@/pages/examples/tables/react-table/sorting')));
const ReactTableFiltering = Loadable(lazy(() => import('@/pages/examples/tables/react-table/filtering')));
const ReactTableGrouping = Loadable(lazy(() => import('@/pages/examples/tables/react-table/grouping')));
const ReactTablePagination = Loadable(lazy(() => import('@/pages/examples/tables/react-table/pagination')));
const ReactTableRowSelection = Loadable(lazy(() => import('@/pages/examples/tables/react-table/row-selection')));
const ReactTableExpanding = Loadable(lazy(() => import('@/pages/examples/tables/react-table/expanding')));
const ReactTableEditable = Loadable(lazy(() => import('@/pages/examples/tables/react-table/editable')));
const ReactTableDragDrop = Loadable(lazy(() => import('@/pages/examples/tables/react-table/drag-drop')));
const ReactTableColumnVisibility = Loadable(lazy(() => import('@/pages/examples/tables/react-table/column-visibility')));
const ReactTableColumnResizing = Loadable(lazy(() => import('@/pages/examples/tables/react-table/column-resizing')));
const ReactTableStickyTable = Loadable(lazy(() => import('@/pages/examples/tables/react-table/sticky')));
const ReactTableUmbrella = Loadable(lazy(() => import('@/pages/examples/tables/react-table/umbrella')));
const ReactTableEmpty = Loadable(lazy(() => import('@/pages/examples/tables/react-table/empty')));
const ReactTableVirtualized = Loadable(lazy(() => import('@/pages/examples/tables/react-table/virtualized')));

// table routing
const MuiTableBasic = Loadable(lazy(() => import('@/pages/examples/tables/mui-table/basic')));
const MuiTableDense = Loadable(lazy(() => import('@/pages/examples/tables/mui-table/dense')));
const MuiTableEnhanced = Loadable(lazy(() => import('@/pages/examples/tables/mui-table/enhanced')));
const MuiTableDatatable = Loadable(lazy(() => import('@/pages/examples/tables/mui-table/datatable')));
const MuiTableCustom = Loadable(lazy(() => import('@/pages/examples/tables/mui-table/custom')));
const MuiTableFixedHeader = Loadable(lazy(() => import('@/pages/examples/tables/mui-table/fixed-header')));
const MuiTableCollapse = Loadable(lazy(() => import('@/pages/examples/tables/mui-table/collapse')));

//table mod routing
const ReactTableMod = Loadable(lazy(() => import('@/pages/examples/tables/mod-table')));

//pdf routing
const ReactPdf = Loadable(lazy(() => import('@/pages/examples/pdf/export')));

//crop image routing
const ReactCrop = Loadable(lazy(() => import('@/pages/examples/crop/crop-image')));

// ==============================|| COMPONENTS ROUTES ||============================== //

const ComponentsRoutes = {
  path: 'components-overview',
  element: <ComponentLayout />,
  children: [
    {
      path: 'autocomplete',
      element: <Autocomplete />
    },
    {
      path: 'buttons',
      element: <Buttons />
    },
    {
      path: 'checkbox',
      element: <Checkbox />
    },
    {
      path: 'radio',
      element: <Radio />
    },
    {
      path: 'rating',
      element: <Rating />
    },
    {
      path: 'switch',
      element: <Switch />
    },
    {
      path: 'select',
      element: <Select />
    },
    {
      path: 'slider',
      element: <Slider />
    },
    {
      path: 'textfield',
      element: <TextField />
    },
    {
      path: 'avatars',
      element: <Avatars />
    },
    {
      path: 'badges',
      element: <Badges />
    },
    {
      path: 'chips',
      element: <Chips />
    },
    {
      path: 'lists',
      element: <Lists />
    },
    {
      path: 'tooltip',
      element: <Tooltip />
    },
    {
      path: 'typography',
      element: <Typography />
    },
    {
      path: 'alert',
      element: <Alert />
    },
    {
      path: 'alert-confirm',
      element: <AlertConfirm />
    },
    {
      path: 'dialogs',
      element: <Dialogs />
    },
    {
      path: 'progress',
      element: <Progress />
    },
    {
      path: 'snackbar',
      element: <Snackbar />
    },
    {
      path: 'breadcrumbs',
      element: <Breadcrumbs />
    },
    {
      path: 'pagination',
      element: <Pagination />
    },
    {
      path: 'speeddial',
      element: <Speeddial />
    },
    {
      path: 'stepper',
      element: <Stepper />
    },
    {
      path: 'tabs',
      element: <Tabs />
    },
    {
      path: 'accordion',
      element: <Accordion />
    },
    {
      path: 'cards',
      element: <Cards />
    },
    {
      path: 'color',
      element: <Color />
    },
    {
      path: 'date-time-picker',
      element: <DateTimePicker />
    },
    {
      path: 'date-time-picker-BE',
      element: <DateTimePickerBE />
    },
    {
      path: 'modal',
      element: <Modal />
    },
    {
      path: 'shadows',
      element: <Shadow />
    },
    {
      path: 'timeline',
      element: <Timeline />
    },
    {
      path: 'treeview',
      element: <TreeView />
    },
    {
      path: 'iconsax',
      element: <Iconsax />
    },
    {
      path: 'icon-themify',
      element: <ThemifyIcon />
    },
    {
      path: 'icon-fontawesome',
      element: <Fontawesome />
    },
    {
      path: 'icon-radix',
      element: <Radix />
    },
    {
      path: 'icon-blueseas',
      element: <BSIcon />
    },
    {
      path: 'icon-simple',
      element: <Simple />
    },
    {
      path: 'icon-hero2',
      element: <Hero2 />
    },
    {
      path: 'icon-bootstrap',
      element: <Bootstrap />
    },
    {
      path: 'export-pdf',
      element: <ReactPdf />
    },
    {
      path: 'crop-image',
      element: <ReactCrop />
    },
    {
      path: 'mod-table',
      element: <ReactTableMod />
    },
    {
      path: 'forms',
      children: [
        {
          path: 'validation',
          element: <FormsValidation />
        },
        {
          path: 'wizard',
          element: <FormsWizard />
        },
        {
          path: 'layout',
          children: [
            {
              path: 'basic',
              element: <FormsLayoutBasic />
            },
            {
              path: 'multi-column',
              element: <FormsLayoutMultiColumn />
            },
            {
              path: 'action-bar',
              element: <FormsLayoutActionBar />
            },
            {
              path: 'sticky-bar',
              element: <FormsLayoutStickyBar />
            }
          ]
        },
        {
          path: 'plugins',
          children: [
            {
              path: 'mask',
              element: <FormsPluginsMask />
            },
            {
              path: 'clipboard',
              element: <FormsPluginsClipboard />
            },
            {
              path: 're-captcha',
              element: <FormsPluginsRecaptcha />
            },
            {
              path: 'editor',
              element: <FormsPluginsEditor />
            },
            {
              path: 'dropzone',
              element: <FormsPluginsDropzone />
            }
          ]
        }
      ]
    },
    {
      path: 'tables',
      children: [
        {
          path: 'react-table',
          children: [
            {
              path: 'basic',
              element: <ReactTableBasic />
            },
            {
              path: 'dense',
              element: <ReactDenseTable />
            },
            {
              path: 'sorting',
              element: <ReactTableSorting />
            },
            {
              path: 'filtering',
              element: <ReactTableFiltering />
            },
            {
              path: 'grouping',
              element: <ReactTableGrouping />
            },
            {
              path: 'pagination',
              element: <ReactTablePagination />
            },
            {
              path: 'row-selection',
              element: <ReactTableRowSelection />
            },
            {
              path: 'expanding',
              element: <ReactTableExpanding />
            },
            {
              path: 'editable',
              element: <ReactTableEditable />
            },
            {
              path: 'drag-drop',
              element: <ReactTableDragDrop />
            },
            {
              path: 'column-visibility',
              element: <ReactTableColumnVisibility />
            },
            {
              path: 'column-resizing',
              element: <ReactTableColumnResizing />
            },
            {
              path: 'sticky-table',
              element: <ReactTableStickyTable />
            },
            {
              path: 'umbrella',
              element: <ReactTableUmbrella />
            },
            {
              path: 'empty',
              element: <ReactTableEmpty />
            },
            {
              path: 'virtualized',
              element: <ReactTableVirtualized />
            }
          ]
        },
        {
          path: 'mui-table',
          children: [
            {
              path: 'basic',
              element: <MuiTableBasic />
            },
            {
              path: 'dense',
              element: <MuiTableDense />
            },
            {
              path: 'enhanced',
              element: <MuiTableEnhanced />
            },
            {
              path: 'datatable',
              element: <MuiTableDatatable />
            },
            {
              path: 'custom',
              element: <MuiTableCustom />
            },
            {
              path: 'fixed-header',
              element: <MuiTableFixedHeader />
            },
            {
              path: 'collapse',
              element: <MuiTableCollapse />
            }
          ]
        }
      ]
    }
  ]
};

export default ComponentsRoutes;
